<app-map *ngIf="type === mapType.NORMAL" [location]="location" [showInitialMarker]="showInitialMarker"></app-map>
<app-map-w3w *ngIf="type === mapType.W3W" [readOnly]="readOnly"></app-map-w3w>
